<template lang="pug">
  .bottommenu
    .bottommenu_inner
      .bottommenu_elem.bottommenu_elem-select
        mf_select(v-bind:value_type="value_type" v-bind:selected="selected.type" v-on:select_value_type="select_value_type" pulltype="upper")
      .bottommenu_elem.bottommenu_elem-slider( v-if="is_board" )
        slider(v-bind:values="years" v-bind:selected="selected_year" v-on:slider_change="change_year")
      .bottommenu_elem.bottommenu_elem-alljapanbutton( v-if="!is_board")
        alljapanbutton(v-bind:is_active="selected.alljapan" v-on:toggle_alljapan="toggle_alljapan")
      .bottommenu_elem.bottommenu_elem-delimiter
        togglebutton(v-bind:selected="selected.sex" v-on:toggle_change="change_sex" v-bind:groupname="get_groupname('toggle')" v-bind:values="sexes")
      .bottommenu_elem
        modeChanger(v-bind:selected="selected.mode" v-on:mode_change="change_mode" v-bind:groupname="get_groupname('mode')")


</template>
<script>
  import {mapGetters, mapState, mapActions} from 'vuex';
  import _ from 'lodash';

  import AllJapanButton from './alljapanbutton.vue';

  export default{
    props: ['type'],
    data: function(){
      let _id = parseInt(Math.random() * 10000);
      return {
        module_id: _id,
      }
    },
    computed: {
      ...mapState([
        'selected',
        'sexes',
        'value_type',
      ]),
      ...mapGetters([
        'get_years',
        'selected_year'
      ]),
      is_board(){
        return /board/.test(this.type);
      },
      years(){
        return this.get_years;
      },
    },
    methods: {
      ...mapActions([
        'selectValueType',
        'changeYear',
        'changeSex',
        'toggle_alljapan',
      ]),
      select_value_type: function(data){
        this.selectValueType(data);
      },
      change_year: _.throttle(function(year){
        this.changeYear(year);
      }, 500),
      change_sex: function(sex){
        this.changeSex(sex);
      },
      change_mode: function(mode){
        this.changeMode(mode);
      },
      get_groupname: function(prefix){
        return prefix + '_' + this.module_id;
      },
    },
    components: {
      alljapanbutton: AllJapanButton
    }
  }

</script>
<style lang="sass">
  .bottommenu
    width: 100%
    background-color: #ccc
    text-align: center
    &_inner
      display: inline-flex
      justify-content: center
      align-items: stretch
    &_elem
      padding: 10px
      box-sizing: border-box
      display: flex
      align-items: center
      &-delimiter
        padding-right: 30px
        border-right: 1px solid #fff
        margin-right: 20px
      &-select
        width: 300px
      &-slider
        width: 230px
      &-alljapanbutton
        width: 100px


</style>